<template>
  <b-card>
    <b-row>
      <b-col md="7" class="p-0">
        <div class="my-2 mb-4 ml-4 mr-4">
          <h1>Create Partner Account</h1>
          <v-stepper alt-labels v-model="e1">
            <v-stepper-header>
              <template v-for="(list, index) in getSteppersList">
                <v-stepper-step
                  :step="index + 1"
                  :key="index + list"
                  class="v-stepper-step-outline"
                  >{{ list }}</v-stepper-step
                >
                <v-divider
                  v-if="index !== getSteppersList.length - 1"
                  :key="index + list"
                />
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content :step="getSteps('office')">
                <s-office
                  :isBillTo="false"
                  :tenants="tenants"
                  @place_changed="setPlace"
                >
                  <template v-slot:footer-button="data">
                    <b-button
                      class="btn btn-block mt-3"
                      btn-color="primary"
                      @click="OfficeToNext(data.data)"
                      >Next</b-button
                    >
                  </template>
                </s-office>
              </v-stepper-content>

              <v-stepper-content :step="getSteps('organization')">
                <s-organization
                  @place_changed="setPlace"
                  :officeData="office"
                  :isLightMode="isLightConfiguration"
                >
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 1" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="OrgToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-organization>
              </v-stepper-content>

              <v-stepper-content
                :step="getSteps('billTo')"
                v-if="!isLightConfiguration"
              >
                <s-office
                  :isBillTo="true"
                  :officeData="office"
                  :setValues="useOfficeDataInBillTo"
                >
                  <template v-slot:name="billname">
                    <b-row class="mt-1 mx-1">
                      <b-form-checkbox
                        type="checkbox"
                        v-model="useOfficeDataInBillTo"
                      >
                        Use same address as office
                      </b-form-checkbox>
                    </b-row>
                    <c-input
                      v-if="!useOfficeDataInBillTo"
                      inputType="text"
                      inputId="name"
                      lableText="Bill Name"
                      v-model="billname.data"
                      class="mt-3"
                    />
                  </template>
                  <template v-slot:footer-button="data">
                    <b-row>
                      <b-col md="2">
                        <v-btn flat @click="e1 = 2" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="BillToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-office>
              </v-stepper-content>

              <v-stepper-content :step="getSteps('authentication')">
                <s-authentication
                  :officeData="office"
                  :isLightMode="isLightConfiguration"
                >
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn
                          v-if="!isLightConfiguration"
                          flat
                          @click="e1 = 3"
                          btn-back="primary"
                        >
                          <span class="fa fa-reply"></span>
                        </v-btn>
                        <v-btn v-else flat @click="e1 = 2" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AuthToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-authentication>
              </v-stepper-content>
              <v-stepper-content :step="getSteps('agreement')">
                <s-agreement
                  :catalogDomainData="catalogDomainData"
                  :showPaymentPicker="
                    (office &&
                      office.category &&
                      office.category.value === 'DISTRIBUTOR') ||
                    (office &&
                      office.category &&
                      office.category.value === 'DEALER')
                  "
                  :showsellerPaymentPicker="
                    office &&
                    office.category &&
                    office.category.value === 'SELLER'
                  "
                >
                  <template v-slot:footer-button="data">
                    <br />
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn
                          v-if="!isLightConfiguration"
                          flat
                          @click="e1 = 4"
                          btn-back="primary"
                        >
                          <span class="fa fa-reply"></span>
                        </v-btn>
                        <v-btn v-else flat @click="e1 = 3" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AgreeToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-agreement>
              </v-stepper-content>

              <v-stepper-content :step="getSteps('done')">
                <s-thanks @done="done"></s-thanks>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </b-col>
      <b-col md="5" col-4="image" class="p-0">
        <img
          src="img/png/createPartner.png"
          class="img-avatar"
          v-if="e1 != 2 && e1 != 1"
        />
        <div v-else>
          <GmapMap
            :center="position"
            :zoom="10"
            map-type-id="terrain"
            style="width: 540px; height: 541px"
          >
            <GmapMarker label="★" :draggable="false" :position="position" />
          </GmapMap>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import sOffice from "@/components/Partner/OfficeStepper.vue";
import sOrganization from "@/components/Partner/OrganizationStepper.vue";
import sAuthentication from "@/components/Partner/AuthenticationStepper.vue";
import sThanks from "@/components/Partner/ThankYouStepper.vue";
import sAgreement from "@/components/Partner/Agreement.vue";
import { mapGetters, mapActions } from "vuex";
import { getReverseGeoCode } from "@/services/geocode";
import currentUserMix from "@/mixins/currentUser";

export default {
  name: "CreatePartner",
  components: {
    sOffice,
    sOrganization,
    sAuthentication,
    sThanks,
    sAgreement,
    cInput,
  },
  mixins: [currentUserMix],
  data() {
    return {
      formFillupCheckerKey: true,
      e1: 0,
      catalogDomainData: "",
      currentUser: "",
      tenants: [],
      office: null,
      organization: null,
      billTo: null,
      authentication: null,
      agreement: null,
      markers: [],
      place: null,
      isLightConfiguration: true,
      useOfficeDataInBillTo: true,
      position: {
        lat: 0,
        lng: 0,
      },
    };
  },
  computed: {
    getSteppersList() {
      const data = [];
      data.push("Office");
      data.push("Organization");
      if (!this.isLightConfiguration) {
        data.push("Bill_To");
      }
      data.push("Authentication");
      data.push("Agreement");
      data.push("Done");
      return data;
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    ...mapGetters({
      tenantPreferences: "tenant/GetTenantPreferences",
      getCategoryList: "catalog/GetCategoryList",
    }),
  },
  methods: {
    async OfficeToNext(item) {
      if (
        item.category &&
        item.category.value &&
        item.officeName != "" &&
        item.address.country != "" &&
        item.address.city != "" &&
        item.address.state != ""
      ) {
        this.office = item;
        this.e1 = 2;
      } else {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
    async OrgToNext(item) {
      if (item.name != "") {
        this.organization = item;
        this.e1 = 3;
      } else {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
    async BillToNext(item) {
      this.billTo = item;
      try {
        const data = await getReverseGeoCode(
          `${this.billTo.address.street1},${this.billTo.address.city},${this.billTo.address.state},${this.billTo.address.country}`
        );
        if (data.data.status === "OK") {
          this.billTo.address.location.coordinates = [
            data.data.results[0].geometry.location.lng,
            data.data.results[0].geometry.location.lat,
          ];
        }
        this.e1 = 4;
      } catch (error) {}
    },
    async AuthToNext(item) {
      if (!item.passwordValid) {
        this.$swal({
          title: "Password Validation failed.",
          text: "Enter a strong password !!!",
          type: "warning",
        });
        return;
      }
      delete item.passwordValid;
      if (
        item.email != "" &&
        item.phone != "" &&
        item.userName != "" &&
        item.password != "" &&
        item.securityQuestions &&
        item.securityQuestions.answer &&
        item.securityQuestions.question.value
      ) {
        this.authentication = item;
        this.e1 += 1;
      } else {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
    async AgreeToNext(item) {
      const userLoginData = JSON.parse(sessionStorage.getItem("userLogin"));
      this.agreement = item;
      const { organization, billTo, office, authentication, agreement } = this;
      const authenticationCopy = { ...authentication };
      try {
        authenticationCopy.securityQuestions = {
          ...authentication.securityQuestions,
          question: authentication.securityQuestions.question.value,
        };
      } catch (err) {}
      let authorization = {};
      let orgaccess = [];
      try {
        if (
          organization.orgAccessList !== null &&
          organization.orgAccessList.length > 0
        ) {
          organization.orgAccessList.map((obj) => {
            orgaccess.push(obj._id);
          });
        }
      } catch (err) {
        this.$swal({
          title: "Error",
          text: "Please orgo access level properly",
          type: "error",
        });
      }

      authorization.orgAccess = {
        orgAccessLevel: "Global",
        orgAccessList: orgaccess,
      };
      const organizationCopy = {
        name: organization.name,
        logo: organization.logo,
        registrationNo: organization.registrationNo,
        gstNo: organization.gstNo,
        fssciNo: organization.fssciNo,
        isOwnCompany: organization.isOwnCompany,
      };
      let tenant = this.$store.getters["auth/getUserID"];
      if (sessionStorage.getItem("userRole") !== "Tenant") {
        tenant = userLoginData.tenant;
      }
      let agreementData = [];
      try {
        if (
          Array.isArray(agreement.catalogCategory) &&
          agreement.catalogCategory.length > 0
        ) {
          if (agreement.fetchCatagoryKey) {
            agreement.catalogCategory.map((obj) => {
              agreementData.push({
                categoryType: "CATEGORY",
                catalogId: obj._id,
              });
            });
          } else {
            agreement.catalog.map((obj) => {
              agreementData.push({
                categoryType: agreement.market.value,
                catalogId: obj._id,
              });
            });
          }
        } else {
          agreement.catalog.map((obj) => {
            agreementData.push({
              categoryType: agreement.market.value,
              catalogId: obj._id,
            });
          });
        }
        this.formFillupCheckerKey = true;
      } catch (err) {
        this.formFillupCheckerKey = false;
        this.$swal({
          title: "Error",
          text: "Please select market and catalog properly",
          type: "error",
        });
      }
      let agreementPayload = {
        doc: agreement.file,
        valid: agreement.valid,
        marketSegment: agreementData,
      };

      const payload = {
        authentication: authenticationCopy,
        authorization,
        agreement: agreementPayload,
        office,
        organization: organizationCopy,
        tenant,
        category: office.category.value,
        officeHierarchy: userLoginData._id,
      };
      if (this.billTo) {
        payload.billTo = billTo;
      } else {
        payload.billTo = {
          address: office.address,
        };
      }

      if (this.formFillupCheckerKey) {
        await this.$store
          .dispatch("partner/createPartner", payload)
          .then(async (result) => {
            this.currentUser = result.response._id;
            if (office.category.value == "SELLER") {
              if (agreement.paymentTypeOnline) {
                const dataObj = {
                  partner: result.response._id,
                  UPIID: agreement.UPIID,
                };

                await this.updatePartnerPreference(dataObj)
                  .then(async (response) => {})
                  .catch((error) => {});
              }

              let payloadSetConfig = {
                id: this.currentUser,
                data: {
                  paymentMethod: {
                    cod: agreement.paymentTypeCod,
                    online: agreement.paymentTypeOnline,
                  },
                  modeOfSale: agreement.modeOfSale,
                  offlineSaleType: "POS",
                },
              };

              await this.$store
                .dispatch(
                  "partner/updatePartnerPaymentPreferencesAction",
                  payloadSetConfig
                )
                .then((result) => {})
                .catch((err) => {});
              if (agreement.paymentTypeOnline) {
                let payloadAcountDetails = {
                  id: this.currentUser,
                  data: {
                    category: office.category.value,
                    bank: {
                      name: agreement.bankName,
                      accountNo: agreement.accountNumber,
                      ifscCode: agreement.ifscCode,
                      accountName: agreement.accountName,
                      email: agreement.accEmail,
                      phone: agreement.accphone,
                    },
                  },
                };

                if (
                  agreement.vendorModeOptionSelect != "" &&
                  agreement.vendorModeOptionSelect.value == "PAYTM"
                ) {
                  payloadAcountDetails.data.paytm = {
                    vendorId: agreement.venderId,
                  };
                }
                if (
                  agreement.vendorModeOptionSelect != "" &&
                  agreement.vendorModeOptionSelect.value == "CASHFREE"
                ) {
                  payloadAcountDetails.data.cashfree = {
                    vendorId: agreement.venderId,
                  };
                }

                await this.$store
                  .dispatch(
                    "partner/updatePartnerPaymentConfigAction",
                    payloadAcountDetails
                  )
                  .then((result) => {
                    this.$swal({
                      title: "Success",
                      text: "Partner details submitted successfully!",
                      type: "success",
                    });
                    if (this.isLightConfiguration) {
                      this.e1 = 5;
                    } else {
                      this.e1 = 6;
                    }
                  })
                  .catch((err) => {
                    this.$swal({
                      title: "Error",
                      text: "Could not create partner",
                      type: "error",
                    });
                  });
              } else {
                this.$swal({
                  title: "Success",
                  text: "Partner details submitted successfully!",
                  type: "success",
                });
                if (this.isLightConfiguration) {
                  this.e1 = 5;
                } else {
                  this.e1 = 6;
                }
              }
            } else {
              const dataObj = {
                partner: result.response._id,
                UPIID: agreement.UPIID,
              };

              await this.updatePartnerPreference(dataObj)
                .then(async (response) => {})
                .catch((error) => {});

              let payloadPref = {
                id: this.currentUser,
                data: {
                  paymentMethod: {
                    cod: agreement.paymentOptionKeys.includes("COD"),
                    online: agreement.paymentOptionKeys.includes(
                      "CASHFREE",
                      "PAYTM"
                    ),
                  },
                },
              };
              await this.$store
                .dispatch(
                  "partner/updatePartnerPaymentPreferencesAction",
                  payloadPref
                )
                .then((result) => {})
                .catch((err) => {});

              if (agreement.paymentOptionKeys.includes("CASHFREE", "PAYTM")) {
                let payloadFinalConfig = {
                  id: this.currentUser,
                  data: {
                    category: office.category.value,
                  },
                };
                if (agreement.paymentOptionKeys.includes("CASHFREE")) {
                  payloadFinalConfig.data.cashfree = {
                    appId: agreement.appkeyCashFree,
                    secretKey: agreement.secretkeyCashFree,
                  };
                }
                if (agreement.paymentOptionKeys.includes("PAYTM")) {
                  payloadFinalConfig.data.paytm = {
                    appId: agreement.appkeyPaytm,
                    secretKey: agreement.secretkeyPaytm,
                  };
                }
                await this.$store
                  .dispatch("tenant/setPaymentConfigAction", payloadFinalConfig)
                  .then((result) => {
                    this.$swal({
                      title: "Success",
                      text: "Partner details submitted successfully!",
                      type: "success",
                    });
                    if (this.isLightConfiguration) {
                      this.e1 = 5;
                    } else {
                      this.e1 = 6;
                    }
                  })
                  .catch((err) => {
                    this.$swal({
                      title: "Error",
                      text: "Could not create Partner",
                      type: "error",
                    });
                  });
              } else {
                this.$swal({
                  title: "Success",
                  text: "Partner details submitted successfully!",
                  type: "success",
                });
                if (this.isLightConfiguration) {
                  this.e1 = 5;
                } else {
                  this.e1 = 6;
                }
              }
            }
          })
          .catch((error) => {
            this.$swal({
              title: "Error",
              text: "Could not create partner",
              type: "error",
            });
          });
      } else {
      }
    },
    done() {
      this.$router.push({ path: "/partner" });
    },
    async setPlace(data) {
      let place = await data;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
    },
    getSteps(key) {
      if (!this.isLightConfiguration) {
        switch (key) {
          case "office":
            return 1;
          case "organization":
            return 2;
          case "billTo":
            return 3;
          case "authentication":
            return 4;
          case "agreement":
            return 5;
          case "done":
            return 6;
        }
      } else {
        switch (key) {
          case "office":
            return 1;
          case "organization":
            return 2;
          case "authentication":
            return 3;
          case "agreement":
            return 4;
          case "done":
            return 5;
        }
      }
    },
    ...mapActions({
      getPreference: "tenant/getTenantPreferences",
      updatePartnerPreference: "partner/updatePartnerPreferences",
      getPartnerPaymentPreferencesAction:
        "partner/getPartnerPaymentPreferencesAction",
    }),
  },
  async mounted() {
    await this.$store.dispatch(
      "partner/getPartnerPaymentConfigAction",
      this.$currentUserData._id
    );

    if (sessionStorage.getItem("userRole") == "Tenant") {
      await this.getPreference(this.$currentUserData._id);
    }
    if (sessionStorage.getItem("userRole") == "Partner") {
      await this.getPartnerPaymentPreferencesAction(this.$currentUserData._id);
    }
    this.catalogDomainData = this.$currentUserData.catalogInfo;
    this.isLightConfiguration = this.tenantPreferences.lightMode;
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  width: 90%;
  border-radius: inherit;
  margin: 150px 40px !important;
}
</style>
<style>
.v-stepper {
  box-shadow: none;
  /* padding: 19px; */
}

.v-stepper__header {
  box-shadow: none;
}

.v-btn:before {
  opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 0px;
}

.v-stepper-step-outline {
  border: 1px solid #727cf5 !important;
  height: 0px;
  border-radius: 50%;
  width: 0px;
  margin-top: 8px;
  /* margin-right: 0px; */
  /* margin-left: 0; */
  margin-bottom: 40px;
  float: left;
}
@-moz-document url-prefix() {
  .v-stepper-step-outline {
    padding: 24px 4px 24px 4px;
  }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
  color: #ffffff;
  background-color: #727cf5 !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
  margin-right: 0;
  margin-bottom: 22px;
  margin-top: -21px;
}
.v-stepper__step__step {
  min-height: 42px;
  min-width: 42px !important;
}
.v-stepper__content {
  padding: 0px !important;
  margin-top: 25px;
}
/* Deactive Stepper */
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: #8badd6 !important;
}
/* divider between steppers */
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px 0px;
  -ms-flex-item-align: start;
  align-self: flex-start;
}
</style>
